export interface IAdditionalData {
  documentType: string;
  documentNumber: string;
  purchaseOrder: string;
  applyRetention: boolean;
  applyDetraction: boolean;
  bankAccountNumber: string;
  detractionPercentage: string;
  sendWhatsapp: boolean;
  whatsappNumber: string;
  sendEmail: boolean;
  email: string;
}

export const DEFAULT_ADDITIONAL_DATA: IAdditionalData = {
  documentType: "",
  documentNumber: "",
  purchaseOrder: "",
  applyRetention: false,
  applyDetraction: false,
  bankAccountNumber: "",
  detractionPercentage: "",
  sendWhatsapp: false,
  whatsappNumber: "",
  sendEmail: false,
  email: "",
};